module.exports = __webpack_public_path__ + "static/media/platform-apple.f902cec7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/platform-apple.svg
// module id = 679
// module chunks = 0